import { debounce } from './helpers/main';
import { checkPostCode, removeError } from './helpers/validation';

const inputSearchField = document.querySelector(".b-search-input");
const inputWrapperImage = document.querySelector(".b-form-field__icon-img");
const submitButton = document.querySelector(".b-form-submit__button");
const branchesResultList = document.getElementById('b-branches-list');
const branchesResultBlock = document.getElementById('b-branches-result');
const postCode = document.getElementById('post-code');
const formToSubmit = document.getElementById('post-code-form');
const selectCountry = document.getElementById('select-country-address');
const appointmentCountryIsoAttribute = document.getElementById('scope-country-iso');
const placeholderSelectorColor = 'rgba(33,63,107,0.3)';
let validationCodeLength = 5;

if (inputWrapperImage) {
  inputSearchField.addEventListener('input', updateValue);
}

if (selectCountry && !selectCountry.value) {
  selectCountry.style.color = placeholderSelectorColor;
}

inputSearchField.focus();

submitButton.disabled = true;

function removeInputValue(e) {
  postCode.value = '';
  inputWrapperImage.src = inputWrapperImage.dataset.defaultIcon;
  if (branchesResultList && branchesResultBlock) {
    branchesResultList.innerHTML = '';
    branchesResultBlock.style.display = 'none';
  }
  inputWrapperImage.removeEventListener('click', removeInputValue);
}

function updateValue(e) {
  inputWrapperImage.addEventListener('click', removeInputValue);
  if (e.target.value.length) {
    inputWrapperImage.src = inputWrapperImage.dataset.clearIcon;
    inputWrapperImage.style.cursor = 'pointer';
  } else {
    inputWrapperImage.src = inputWrapperImage.dataset.defaultIcon;
    inputWrapperImage.style.cursor = 'none';
  }
}

formToSubmit.addEventListener('change', debounce(function (e) {
  switch (e.target.id) {
    case 'post-code':
      checkPostCode(postCode, true, validationCodeLength);
      break;
  }
}));

formToSubmit.addEventListener('submit', function (e) {
  // validate forms
  let isFormValid;
  if (selectCountry) {
    isFormValid = checkPostCode(postCode, true, validationCodeLength) && selectCountry.value;
  } else {
    isFormValid = checkPostCode(postCode);
  }

  // submit to the server if the form is valid
  if (!isFormValid) {
    // prevent the form from submitting
    e.preventDefault();
  }
});

formToSubmit.addEventListener('input', function (e) {
  // prevent the form from submitting
  e.preventDefault();

  if (selectCountry) {
    submitButton.disabled = !checkPostCode(postCode, false, validationCodeLength) || !selectCountry.value
  } else {
    submitButton.disabled = !checkPostCode(postCode, false);
  }
});

formToSubmit.addEventListener('keypress', function (evt) {
  if ((evt.which < 48 || evt.which > 57) && evt.which !== 13) {
    evt.preventDefault();
  }
});

if (selectCountry) {
  if (selectCountry && selectCountry.value === 'CHE') {
    validationCodeLength = 4;
  } else {
    validationCodeLength = 5;
  }
  selectCountry.addEventListener("change", function(e) {
    if (selectCountry.value) {
      removeError(postCode)
      if (appointmentCountryIsoAttribute) {
        appointmentCountryIsoAttribute.value = selectCountry.value;
      }
      selectCountry.style.color = '';
      if (selectCountry && selectCountry.value === 'CHE') {
        validationCodeLength = 4;
      } else {
        validationCodeLength = 5;
      }
    } else {
      if (appointmentCountryIsoAttribute) {
        appointmentCountryIsoAttribute.value = '';
      }
      selectCountry.style.color = placeholderSelectorColor;
    }
    postCode.value = '';
    submitButton.disabled = !checkPostCode(postCode, false, validationCodeLength) || !selectCountry.value
  });
}
